import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
    //список штрафов
    items:[],

  },
  actions,
  mutations,
  getters
}
